var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUptimeSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 26,
    viewBox: "0 0 91 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3524_67175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.91895 15.7089C5.91895 12.5341 11.3926 11.6857 11.3926 10.071C11.3926 8.9215 10.1337 8.56571 9.03895 8.56571C8.08105 8.56571 7.06842 8.81203 6.41158 9.00361V7.71729C6.87684 7.44361 7.61579 7.16992 9.17579 7.16992C11.1737 7.16992 12.8432 7.74466 12.8432 10.0162C12.8432 13.0815 8.08105 12.8899 7.47895 15.9552H12.8158V17.2962H5.91895V15.7089Z",
    fill: "#083F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4283 14.3677H11.4473V12.5614C12.8704 10.7825 14.2115 9.0309 15.662 7.25195H17.8788V12.972H19.3567V14.3677H17.8788V17.2962H16.4283V14.3677ZM16.4283 12.972V8.59301L12.9525 12.972H16.4283Z",
    fill: "#083F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9741 7.25195H25.6794V9.0309L21.7657 17.2962H20.151L24.311 8.64774H18.9741V7.25195Z",
    fill: "#98BCC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1342 18.9116C21.1089 22.1137 17.551 24.2211 13.5279 24.2211C7.23312 24.2211 2.14259 19.1305 2.14259 12.8358C2.14259 7.28 6.16575 2.65474 11.4479 1.66947V0C5.23522 0.985263 0.500488 6.37684 0.500488 12.8358C0.500488 20.0063 6.32996 25.8632 13.5279 25.8632C18.5089 25.8632 22.8605 23.0442 25.05 18.9116H23.1342Z",
    fill: "#98BCC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7847 19.0499V7.96566H52.0078V7.0625H60.6015V7.96566H56.8247V19.0499H55.7847Z",
    fill: "#98BCC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0371 19.0499V7.0625H64.1045V19.0499H63.0371Z",
    fill: "#98BCC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4019 19.0499V7.0625H69.9619L73.6292 15.8478L73.7113 16.1214H73.7934L73.8755 15.8478L77.5429 7.0625H79.1029V19.0499H78.0629L78.0903 8.64987L78.1176 8.18461H77.9808L74.3134 17.0793H73.1092L69.4966 8.21197H69.3598L69.3871 8.64987L69.4145 19.0499H68.4019Z",
    fill: "#98BCC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6939 12.4531H85.8076V13.3563H89.6939V12.4531Z",
    fill: "#98BCC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5425 7.0625H83.4541V19.0499H90.5425V18.1741H84.5215V7.96566H90.5425V7.0625Z",
    fill: "#98BCC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6555 19.2962C33.0408 19.2962 31.8092 18.8583 31.0155 17.9551C30.3587 17.2162 30.0303 16.2857 30.0303 15.1088V7.0625H31.8913V15.1909C31.8913 15.8478 32.0829 16.4225 32.4661 16.8878C32.9587 17.4899 33.6976 17.7909 34.6829 17.7909C35.6955 17.7909 36.4345 17.4899 36.9271 16.8878C37.2829 16.4499 37.4745 15.8751 37.4745 15.1909V7.0625H39.3355V15.0541C39.3355 15.793 39.1987 16.4499 38.8976 17.052C38.5692 17.7362 38.0766 18.2836 37.4471 18.6393C36.6534 19.0772 35.7503 19.2962 34.6555 19.2962Z",
    fill: "#083F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0092 7.91092C49.3797 7.33618 48.4492 7.0625 47.2723 7.0625H42.5376V19.0499H44.3987V8.59513H46.9439C47.7376 8.59513 48.3123 8.78671 48.6955 9.16987C48.9965 9.49829 49.1608 9.96355 49.1608 10.5657V11.113C49.1608 11.8246 48.9965 12.3446 48.6408 12.673C48.2576 13.0288 47.6555 13.2204 46.8071 13.2204H45.7397V14.753H47.1629C48.4218 14.753 49.3797 14.452 50.0365 13.8499C50.6934 13.2478 51.0218 12.3993 51.0218 11.2499V10.3467C50.9671 9.30671 50.6387 8.51303 50.0092 7.91092Z",
    fill: "#083F51"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3524_67175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90.0421,
    height: 26,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUptimeSvg);
export default __webpack_public_path__ + "static/media/uptimeSvg.2416c874.svg";
export { ForwardRef as ReactComponent };